export default {
  clientesCadastrados: {},
  clientesCadastradosTotal: {},
  clientesAtivos: {},
  mediaCompras: {},
  gastoMedio: {},
  faturamento: [],
  percentualFaturamentoFidelidade: [],
  ticketMedioFidelidade: {},
  ticketMedio: {},
  percentualTicketMedio: {},
  mediaItens: {},
  cuponsFidelidade: {},
  faturamentoFidelidade: {},
  cuponsFora: {},
  faturamentoFora: {},
  inicioFidelidade: false,
  performanceOperacional: [],
  percentualCuponsIdentificados: [],
  percentualFaturamentoIdentificado: [],
  detalhesOperador: [],
  comparativoCharts: [],
  comparativoCards: [],
  metricsUnitsComparision: [],
}
